import { SignalDot } from '@indipia/ui-core'
import { SIGNAL_COLOR_LABEL } from '../../constants/signalView'
import type { ScheduleListRow } from '../../types/scheduleList.types'
import { cellStatusText, DIM_TEXT_STYLE } from './listStyle'

// 공종 칸(D-05 ①) — 윗줄 신호 점 1개(공종명 앞, 3신호 중 가장 급한 색) + 공종명, 아랫줄 선행 목록. 공종 색 네모는 두지 않는다.
// 점 title = `반장 … · 발주 … · 작업 …`. 대표색이 흰색이어도 점을 그대로 그린다('셋 다 흰색 숨김' 미적용, 확정결정 9).

export interface ScheduleListWorkTypeCellProps {
  row: ScheduleListRow
}

export function ScheduleListWorkTypeCell({ row }: ScheduleListWorkTypeCellProps) {
  const dotColor = row.signalMissing ? 'NONE' : row.representativeColor
  const dotLabel = row.signalMissing ? '대표 신호 없음' : `대표 신호 ${SIGNAL_COLOR_LABEL[row.representativeColor]}`
  const dotTitle = `시공파트너 ${cellStatusText(row.cells.foreman)} · 발주 ${cellStatusText(row.cells.order)} · 작업 ${cellStatusText(row.cells.work)}`
  const pred = row.predecessors.length > 0 ? `선행 ${row.predecessors.map(p => p.workTypeName).join(', ')}` : '선행 없음'
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-01)' }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 'var(--spacing-03)' }}>
        {/* 스케줄 전용 행정 공정은 신호가 없어 점을 그리지 않는다 */}
        {!row.scheduleOnly && <SignalDot color={dotColor} size={10} label={dotLabel} title={dotTitle} />}
        <span style={{ fontSize: 'var(--type-body-sm-size)', fontWeight: 700, color: 'var(--shell-on-surface)' }}>{row.workTypeName}</span>
      </span>
      <span style={DIM_TEXT_STYLE}>{pred}</span>
    </div>
  )
}
